export const SCHEDULE_MISSING_DATES = 'Select a date range on the scheduler to schedule a booking'
export const REQUEST_MISSING_DATES = 'Create a request by making a selection on the scheduler'
export const SCHEDULE_NO_PERMISSIONS = 'You have no permissions to schedule a booking'
export const REQUEST_NO_PERMISSIONS = 'You have no permissions to make a request'
export const SCHEDULE_UW_PARENT = `You can't schedule on unassigned parent row`
export const REQUEST_UW_PARENT = `You can't make a request on unassigned parent row`
